import React, { Component } from "react";
import SidePane from "react-sliding-pane";
import AppLoader from "../../../app-components/app-loader.jsx";

const ORANGE = "#fb4d24";

class ArticlePicker extends Component {
  handleKey = (e) => {
    if (e.key === "Enter") this.doSearch();
  };

  doSearch = () => {
    const el = document.querySelector("#hpTrendingSearch");
    this.props.searchArticles(el ? el.value : "");
  };

  render() {
    const { open, search, selectArticle, closePicker, selectedIds = [] } = this.props;
    return (
      <SidePane
        isOpen={open}
        title="Add article"
        subtitle="Search by title, or paste an article URL of this site"
        from="right"
        width="80%"
        onRequestClose={closePicker}
      >
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}>
          <div style={{ position: "relative", marginTop: 15, width: "80%", minWidth: 300 }}>
            <input
              id="hpTrendingSearch"
              autoFocus
              placeholder="Search article title, or paste article URL..."
              onKeyPress={this.handleKey}
              style={{
                width: "100%", height: 46, borderRadius: 5, paddingLeft: 10, fontSize: 16,
                border: "1px solid #e7e7e7", backgroundColor: "#f5f5f5",
                boxShadow: "0 1px 8px 0 rgba(0,0,0,0.06)",
              }}
            />
            <div style={{ position: "absolute", right: 15, top: 15, cursor: "pointer" }} onClick={this.doSearch}>
              <i className="material-icons">search</i>
            </div>
          </div>

          {search.query ? (
            <div style={{ width: "80%", marginTop: 20 }}><em>Results for {search.query}</em></div>
          ) : null}
          {search.isSearching ? <AppLoader message="Searching..." /> : null}

          <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", width: "90%", marginTop: 10 }}>
            {!search.isSearching && search.results.length === 0 ? (
              <div style={{ color: "#8d8d8d", padding: 20 }}>Search a title or paste an article URL above to find articles.</div>
            ) : null}
            {search.results.map((a) => {
              const already = selectedIds.indexOf(a.articleId) > -1;
              return (
                <div key={a.articleId} style={{ width: 260, margin: 10, border: "1px solid #eeeeee", borderRadius: 6, overflow: "hidden" }}>
                  <img src={a.thumbnail || ""} alt="" style={{ width: "100%", height: 140, objectFit: "cover", background: "#eeeeee" }} />
                  <div style={{ padding: 10 }}>
                    <div style={{ fontWeight: 600, fontSize: 13, minHeight: 54, color: "#232323" }}>{a.title}</div>
                    <button
                      disabled={already}
                      onClick={() => selectArticle(a)}
                      style={{
                        marginTop: 8, width: "100%", height: 34, border: "none", borderRadius: 4,
                        cursor: already ? "default" : "pointer", color: "#ffffff",
                        backgroundColor: already ? "#bbbbbb" : ORANGE,
                      }}
                    >
                      {already ? "Already added" : "Select"}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </SidePane>
    );
  }
}

export default ArticlePicker;
